import { render, staticRenderFns } from "./global-popups.vue?vue&type=template&id=608cd4e8&scoped=true"
import script from "./global-popups.vue?vue&type=script&lang=js"
export * from "./global-popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cd4e8",
  null
  
)

export default component.exports